import { EmployeePermissionFull } from 'src/api/permissions';

import { PermissionsState } from './types';

export const emptyPermissions: EmployeePermissionFull[] = [];

export const initialState: PermissionsState = {
  loading: false,
  employee: null,
  permissions: emptyPermissions,
};
